import { Link } from "react-router-dom";
import { Check, X, Settings, Building2, LayoutDashboard } from "lucide-react";
import { useLang } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { Section } from "./common";
import { roleLabel } from "./UserAvatar";
import { PERMS } from "../pages/Team";

export function MyCompany() {
  const { t, lang } = useLang();
  const { user, can } = useAuth();
  const owner = user.role === "owner";
  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <Section title={t("My company", "Mi empresa")} testid="profile-company-section">
        <div className="p-4 grid gap-2 text-sm">
          <div>{t("Company", "Empresa")}: <b data-testid="profile-company-name">{user.company?.name || "—"}</b></div>
          <div>{t("Role", "Rol")}: <b data-testid="profile-company-role">{roleLabel(t, user.role)}</b></div>
          {user.platform_admin && <div className="font-bold text-[#D9531E]" data-testid="profile-company-platform">Platform Super Admin</div>}
          <p className="text-xs text-slate-500 mt-2">{t("Company name, logo, business contact, license, branding and PDF settings are managed in Company Settings, separate from your personal profile.", "El nombre, logo, contacto, licencia, marca y PDF de la empresa se administran en Configuración de la empresa, separado de su perfil personal.")}</p>
          <div className="flex flex-wrap gap-2 mt-2">
            {can("settings") && <Link to="/settings" className="btn-outline btn-sm" data-testid="profile-company-settings-link"><Settings className="w-4 h-4" /> {t("Company Settings", "Configuración de la empresa")}</Link>}
            {user.platform_admin && <Link to="/companies" className="btn-outline btn-sm" data-testid="profile-companies-link"><Building2 className="w-4 h-4" /> {t("Companies", "Empresas")}</Link>}
            {user.platform_admin && <Link to="/platform" className="btn-outline btn-sm" data-testid="profile-platform-link"><LayoutDashboard className="w-4 h-4" /> {t("Platform Administration", "Administración de la plataforma")}</Link>}
          </div>
        </div>
      </Section>
      <Section title={t("My permissions", "Mis permisos")} testid="profile-permissions-section">
        {owner && <p className="px-4 pt-3 text-sm font-semibold text-emerald-700" data-testid="profile-full-access">{t("Owner: full access to everything", "Dueño: acceso completo a todo")}</p>}
        <div className="p-4 grid gap-1">
          {PERMS.map(([k, en, es]) => {
            const ok = owner || user.permissions?.[k];
            return (
              <div key={k} className="flex items-center gap-2 text-sm" data-testid={`profile-perm-${k}`}>
                {ok ? <Check className="w-4 h-4 text-emerald-600" /> : <X className="w-4 h-4 text-slate-300" />}
                <span className={ok ? "" : "text-slate-400"}>{lang === "es" ? es : en}</span>
              </div>
            );
          })}
        </div>
      </Section>
    </div>
  );
}
